
import { Region } from '../types/region-types';

export const base_regions: Region[] = [
  {
    region_id: "CDMX",
    english_name: "Mexico City",
    spanish_name: "Ciudad de México",
    church_presence: "Good",
    pledges: 300000,
    target_need: 300000,
    missionaries: 45,
    languages: ["Spanish"],
    coordinates: [-99.1332, 19.4326],
    church_funding: []
  },
  {
    region_id: "CHIS",
    english_name: "Chiapas",
    spanish_name: "Chiapas", 
    church_presence: "Low",
    pledges: 220000,
    target_need: 220000,
    missionaries: 12,
    languages: ["Spanish", "Maya", "Zapotec", "Totonac"],
    coordinates: [-92.2725, 16.7535],
    church_funding: []
  },
  {
    region_id: "HGO",
    english_name: "Hidalgo",
    spanish_name: "Hidalgo",
    church_presence: "Low",
    pledges: 190000,
    target_need: 190000,
    missionaries: 10,
    languages: ["Spanish", "Nahuatl", "Otomi"],
    coordinates: [-98.7577, 20.4859],
    church_funding: []
  }
];
